import React, { useState, useEffect, useRef } from 'react';

const ChatNow = ({ variant, text }) => {
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        onClick={() => setIsOpen(true)}
        className={`${variant === 'white' ? 'bg-white' : 'bg-primary'
          } p-4 flex items-center justify-between gap-5 md:min-w-[350px]`}
        style={{ cursor: 'pointer' }}
      >
        {variant === 'white' ? (
          <img src='/assets/images/bubble-chat-blue.svg' alt='' />
        ) : (
          <img src='/assets/images/bubble-chat.svg' alt='' />
        )}
        <p className={`${variant !== 'white' ? 'text-white' : 'text-primary'}`}>
          {text}
        </p>
      </div>

      <div className={`fixed top-0 left-0 w-full h-full  items-center justify-center bg-gray-200 bg-opacity-10  ${isOpen ? 'flex':'hidden'}`} style={{zIndex: 1000}}>
        <div ref={modalRef} className="bg-white p-8 rounded-lg shadow-lg min-w-[90vw] min-h-[90vh]">
          <div>This is the modal content</div>
        </div>
      </div>
    </>
  );
};

export default ChatNow;
